export default function paper({ variables }) {
    return {
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: variables.border_radius_small,
                    backgroundImage: "none", // drop MUI's elevation overlay — flat surfaces
                },
                outlined: {
                    border: `1px solid ${variables.border_subtle}`,
                },
            },
        },
    };
}
//# sourceMappingURL=paper.js.map